import type { GlobalAddress } from "@interfaces/address/globalAddress";
import type { DeliveryInitialValues } from "@lib/utils/checkoutHelper";

export const mapGlobalAddressToDeliveryAddress = (
    address: GlobalAddress
): DeliveryInitialValues => {
    const { address1, city, country, postalCode, region } = address ?? {};

    return {
        streetName: address1,
        city: city,
        region: region,
        postalCode: postalCode,
        country: country,
    };
};
